import { Button, DataGrid, ScrollView } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { getApiParams } from "../../../redux/auth";
import { getLocalized } from "../../../redux/localization";
import BaseService from "../../../services";
import { pendingTicketsUrl } from "../../../services/urls";

function PendingTickets() {
  const localize = useSelector(getLocalized);
  const baseService = new BaseService();
  const tableRef = useRef<any>();
  const { token } = useSelector(getApiParams);
  const columns = [
    {
      dataField: "Code",
      caption: localize.getString("code"),
    },
    {
      dataField: "UserName",
      caption: localize.getString("name"),
    },
    {
      dataField: "Subject",
      caption: "Konu",
    },

    {
      dataField: "TicketType",
      caption: localize.getString("ticketType"),
    },
    {
      type: "buttons",
      width: 110,
      buttons: [
        {
          hint: "Detaya git",
          icon: "exportselected",
          onClick: (e: any) => {
            window.open(
              `#/tickets?selectedTicket=${e.row.data.Id}`,
              "_blank",
              "noopener,noreferrer"
            );
          },
        },
      ],
    },
  ];

  return (
    <>
      <div className="dx-card" style={{ backgroundColor: "white" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "start",
            fontSize: "16px",
            fontWeight: 700,
            paddingInline: 10,
            marginBlock: "5px 5px",
          }}
        >
          <p style={{ color: "#434D6E" }}>Destek Talepleri</p>
          <Button
            hint={"Yenile"}
            icon="refresh"
            type="normal"
            stylingMode="outlined"
            onClick={() => tableRef?.current?._instance?.refresh()}
          />
        </div>
        <div className="grid-div">
          <ScrollView>
            <DataGrid
              ref={tableRef}
              style={{ fontSize: 12 }}
              key="Id"
              className={"custom-data-grid wide-card dashboard-grid"}
              dataSource={
                new CustomStore({
                  key: "Id",
                  //@ts-ignore
                  load: () =>
                    baseService.sendRequest(
                      pendingTicketsUrl,
                      "GET",
                      token,
                      "tr-TR"
                    ),
                })
              }
              showBorders
              showRowLines
              showColumnLines={false}
              columnAutoWidth
              columnHidingEnabled
              rowAlternationEnabled
              allowColumnResizing
              allowColumnReordering
              focusedRowEnabled
              grouping={{
                autoExpandAll: false,
              }}
            >
              {columns.map((column, i) => (
                <Column key={i} {...column} />
              ))}
            </DataGrid>
          </ScrollView>
        </div>
      </div>
    </>
  );
}

export default PendingTickets;
